var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5094 9.57223C14.4069 9.33721 14.1813 9.1875 13.9331 9.1875H11.3998V0.65625C11.3998 0.294082 11.116 0 10.7664 0H8.23311C7.88359 0 7.59978 0.294082 7.59978 0.65625V9.1875H5.06644C4.81826 9.1875 4.59263 9.33844 4.49011 9.57223C4.3864 9.80725 4.42678 10.0816 4.59026 10.2756L9.02359 15.5256C9.14392 15.6688 9.3173 15.75 9.49978 15.75C9.68226 15.75 9.85563 15.6671 9.97597 15.5256L14.4093 10.2756C14.574 10.0825 14.612 9.80684 14.5094 9.57223Z",
    fill: "#ABDFCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4667 14.4375V18.375H2.53333V14.4375H0V19.6875C0 20.4135 0.567625 21 1.26667 21H17.7333C18.434 21 19 20.4135 19 19.6875V14.4375H16.4667Z",
    fill: "#ABDFCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c4c334ff0369be99982fc7fbcaed73f0.svg";
export { ForwardRef as ReactComponent };